import React, { Component } from "react";
import {
  Navbar,
  Button,
  Nav,
  Form,
  Container,
  Row,
  Col,
  Table,
  ButtonToolbar,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSync,
  faPlus,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import { openModal, closeModal } from "../../../../store/actions/ModalActions";
import { toastr } from "react-redux-toastr";
import TableLoader from "../../../../components/extensions/TableLoader";

import {
  GetBranchTargetsCollection,
  GetSingleBranchTargets,
  AddBranchTargets,
  UpdateBranchTargets,
  DeleteBranchTargets,
} from "../../../../store/actions/settings/settings_branch_target_service_actions";

import { connect } from "react-redux";
import moment from "moment";

import InventoryTargetBatchUpload from "./manage_inventory_target_batch_branch";
import ManageInventoryTargetArea from "./manage_inventory_target_branch";
import NoTableData from "../../../../components/extensions/ErrorPageDefaults/NoTableData";
import { numberWithCommas } from "../../../../helpers/dataHelpers";

class InventoryTargetSettingsBranch extends Component {
  state = {
    isLoading: false,
    list: [],
  };

  componentDidMount() {
    this._refresh();
  }

  _refresh = () => {
    this.setState({ isLoading: true });
    this.props.GetBranchTargetsCollection().then((resp) => {
      if (resp.problem === null) {
        this.setState({ list: resp.data, isLoading: false });
      }
      return Promise.resolve(resp);
    });
  };

  _deleteBranchTarget = (id) => {
    return this.props.DeleteBranchTargets({ id: id }).then((resp) => {
      if (resp.problem === null) {
        this._refresh();
        closeModal();
        toastr.success("Deleted", "Branch Category Deleted");
      }
      return Promise.resolve(resp);
    });
  };

  _addBranchTarget = (data) => {
    return this.props.AddBranchTargets(data).then((resp) => {
      if (resp.problem === null) {
        this._refresh();
        closeModal();
        toastr.success("Added", "Branch Category Added");
      }
      return Promise.resolve(resp);
    });
  };

  _editAreaTarget = (data) => {
    return this.props.UpdateBranchTargets(data).then((resp) => {
      if (resp.problem === null) {
        this._refresh();
        closeModal();
        toastr.success("Modified", "Branch Category Modified");
      }
      return Promise.resolve(resp);
    });
  };

  renderOptions = () => {
    return (
      <Navbar className="rounded">
        <Navbar.Collapse>
          <Nav className="mr-auto" />
        </Navbar.Collapse>
        <Form inline>
          <Button
            onClick={() => {
              this._refresh();
            }}
            className="m-1"
            size="md"
            variant="primary"
          >
            <FontAwesomeIcon icon={faSync} className="mr-1" />
            Refresh
          </Button>
          <Button
            onClick={() => {
              openModal({
                title: "Create Branch Target Setting",
                currentComponent: (
                  <ManageInventoryTargetArea
                    mode="Add"
                    add={this._addBranchTarget}
                  />
                ),
              });
            }}
            className="m-1"
            size="md"
            variant="success"
          >
            <FontAwesomeIcon icon={faPlus} className="mr-1" />
            Create Branch Target Setting
          </Button>

          <Button
            onClick={() => {
              openModal({
                title: "Batch Upload Branch Target Settings",
                currentComponent: (
                  <InventoryTargetBatchUpload
                    onRefresh={() => {
                      this._refresh();
                      closeModal();
                    }}
                  />
                ),
              });
            }}
            className="m-1"
            size="md"
            variant="outline-success"
          >
            <FontAwesomeIcon icon={faLayerGroup} className="mr-1" />
            Batch Upload Inventory Targets
          </Button>
        </Form>
      </Navbar>
    );
  };

  renderTable() {
    return this.state.isLoading ? (
      <TableLoader />
    ) : (
        <Table className="bg-white" hover striped variant="light" responsive>
          <thead>
            <th>Branch Code</th>
            <th>Period</th>
            <th>Piece</th>
            <th>Principal</th>
          </thead>
          <tbody>
            {this.state.list.map((item, key) => {
              return (
                <tr key={key}>
                  <td>{item.branchCode}</td>
                  <td>
                    {moment(new Date(item.year, item.month - 1)).format(
                      "MMMM YYYY"
                    )}
                  </td>
                  <td>{numberWithCommas(item.totalPieces)}</td>
                  <td>{numberWithCommas(item.totalPrincipal, 2)}</td>
                  <td>
                    <ButtonToolbar className="float-right m-2">
                      <Button
                        onClick={() => {
                          openModal({
                            title: "Modify Branch Target Setting",
                            currentComponent: (
                              <ManageInventoryTargetArea
                                mode="Edit"
                                data={item}
                                edit={this._editAreaTarget}
                              />
                            ),
                          });
                        }}
                        variant="warning"
                        className="m-1"
                      >
                        Edit
                    </Button>
                      <Button
                        onClick={() => {
                          toastr.confirm(
                            <p>
                              Are you sure you want to inventory Target setting
                            for Branch{" "}
                              <strong className="strong">
                                {item.branchCode}
                              </strong>
                            ?
                          </p>,
                            {
                              okText: "Yes, Delete",
                              onOk: () => {
                                this._deleteBranchTarget(item.id);
                              },
                            }
                          );
                        }}
                        variant="danger"
                        className="m-1"
                      >
                        Delete
                    </Button>
                    </ButtonToolbar>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      );
  }

  render() {
    return (
      <Container fluid className="p-3">
        <Row>
          <Col>{this.renderOptions()}</Col>
        </Row>
        <Row>
          <Col>
            {this.state.list.length > 0 ? this.renderTable() : <NoTableData />}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  GetBranchTargetsCollection,
  GetSingleBranchTargets,
  AddBranchTargets,
  UpdateBranchTargets,
  DeleteBranchTargets,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryTargetSettingsBranch);
